package org.moxultimate.topwithmox.components.footer

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.moxultimate.topwithmox.components.texts.DescriptionText
import org.moxultimate.topwithmox.theme.BlackBG

val FooterStyle = CssStyle.base {
    Modifier
        .backgroundColor(BlackBG)
        .padding(topBottom = 0.5.cssRem, leftRight = 10.percent)
}

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Box(
        FooterStyle.toModifier().then(modifier.fillMaxWidth()),
        contentAlignment = Alignment.Center
    ) {
        DescriptionText(
            modifier = Modifier
                .padding(top = 16.px, bottom = 12.px)
                .textAlign(TextAlign.Center),
            description = "@ 2026 Top With Mox. All rights reserved. Curating the top of everything digital"
        )
    }
}
